export const ERROR_MESSAGES = {
  INVALID_EMAILID: 'Please enter valid email address',
  INVALID_MOBILENO: 'Please enter valid mobile number ',
  INVALID_MOBILENO_LENGTH: 'Mobile number must  be 10 digits.',
  INVALID_EMAILID_AND_MOBILENO: 'Please enter valid mobile no / email-id',

  MOBILENO_ALREADY_REGISTER: 'Mobile number is already registered',
  EMAILID_ALREADY_REGISTER:
    'An account already exists with the same email address. Please use a different sign-in method.',

  MOBILE_NUMBER_NOT_REGISTERED:
    'An account with this number does not exist. Please signup',

  INVALID_COUNTRY_CODE: 'Invalid country code',
  REMOVE_COUNTRY_CODE: 'Invalid mobile number. Please remove Country code',

  OTP_NOT_SENT: 'OTP is not sent. Please check the mobile number again.',
  INVALID_OTP: 'Invalid OTP ',
  OTP_EXPIRE: 'The OTP has expired. Please click on resend OTP.',

  INVALID_PASSWORD: 'Invalid Password.',
  MINIMUM_PASSWORD_LENGTH: 'Minimum password length is 6 characters',
  MAXIMUM_PASSWORD_LENGTH: 'Maximum password length is 16 characters',
  CONFIRM_PASSWORD_MATCH: 'Password and confirm password does not match ',

  INVALID_USER: 'You are not registered. Please signup.',
  INVALID_USER_FULLNAME: 'User name only contains alphabets',
  INVALID_USER_MOBILE_NUMBER:
    'Mobile number should not contain any alphabets and special character.',
  USER_EMAIL_ALREADY_REGISTERED:
    'An account already exists with the same email-id. Please log in',
  USER_PHONE_ALREADY_REGISTERED:
    'An account already exists with the same mobile number. Please log in',
  USER_DATA_ERROR: 'Something went wrong while fetching your information',

  REQUIRED_ERROR: 'This field is required',

  HOTEL_LIST_ERROR_MESSAGES:
    'There is no property in your search criteria! Please try again with different search.',
  WISHLIST_REMOVE_PROPERTY_ERROR:
    'Your property cannot be removed please try later',

  VOUCHER_DOWNLADING_ERROR:
    'Booking Voucher could not be downloaded please try later',
  ENQUIRY_MESSAGE_ERROR:
    'Unfortunately your enquiry could be not be processed please try again later',

  BOOKING_CANCELATION_ERROR:
    'Unfortunately, Your booking could not be cancelled. Please reach out to our customer support for further assistance over email at care@bag2bag.in or call us on +91-9335505099.',
  NO_BOOKING_AVILABLE: 'There is no booking list available',
  BOOKING_DETAILS: 'There is no booking detail available.',
  BOOKING_FAILED_DETAILS: 'Your booking failed',
  BOOKING_NOT_CONFIRMED: `Unfortunately, Your booking could not be completed please try booking the hotel again or reach out to our
    customer support for further assistance over email at care@bag2bag.in or call us on +91-9335505099.`,

  PAY_AT_HOTEL: 'Pay at hotel is only for registered user',
  TOO_MANY_RESEND_OTP_REQUEST:
    'We have blocked all requests from this device due to unusual activity. Try again later.',
  RESEND_OTP_ONLY_TWICE: 'You can use resend OTP Twice',
  ERROR_CREATING_USER: 'Something went wrong please try later',
  ERROR_LOGIN_USER: ' Something went wrong please try later  ',

  LOGIN_AND_SIGNUP_DISABLED_BUTTON: 'Login/Signup first',
  LOGIN_AGAIN: 'Session Timeout.Please login again!',
  DEFAULT_AUTHENTICATION_FAILED:
    'Unfortunately, Authentication is failed please try different sign-in method.',
  NEARBY_DATA_NOT_AVAILABLE_TITLE: 'Near by data is not available.',
  NEARBY_DATA_NOT_AVAILABLE_DESC:
    'Unfortunately, Nearby data is not available for the current property.',
  REVIEWS_NOT_AVAILABLE_TITLE: 'Reviews not available.',
  MAP_LOCATION_NOT_AVAILABLE_TITLE: 'Map location is not available.',
  DATA_NOT_FOUND: 'No results found. Please contact support team.',
  NETWORK_ERROR:
    'A network error (such as timeout, interrupted connection or unreachable host) has occurred.',
  // REVIEWS_NOT_AVAILABLE_DESC: 'Unfortunately, Nearby data is not available for the current property.'
  REVIEWS_NOT_SAVED:
    'Unfortunately, Ratings are not saved. Please try later !!!',
};

export const SUCCESSFULL_MESSAGES = {
  USER_REGISTERED: 'You are Signed-up Successfully',
  USER_LOGGEDIN: ' You are Logged-in Successfully  ',
  OTP_SENT: 'OTP has been sent successfully to your mobile number',
  OTP_RESENT: 'OTP has been resent to your mobile number',
  CHECK_VERIFY_LINK: 'Please check your email and click on verify link.',
  BOOKING_CANCELATION_SUCCESS: 'Your Booking has been cancelled successfully.',
  VOUCHER_DOWNLADING: 'Your Voucher has been downloaded successfully.',
  MY_BOOKING_LIST: 'Your Booking List is Fetched Successfully',
  ENQUIRY_MESSAGE:
    'Your Details has been forwarded to the relevant team and will be dealt with as soon as possible.',
  ADD_WISHLIST: 'Your wishlist is fetched successfully.',
  WISHLIST_REMOVE: 'Property is removed from wishlist successfully',
  THANK_YOU: 'Thank you for booking the hotel with Bag2Bag.',
  USER_DATA: 'User information is get successfully',
  THANK_YOU_FOR_YOUR_FEEDBACK: 'Thank you for your valuable feedback.',
  HOTEL_LIST_MESSAGE: 'Fetch Property list is successfull.',
  THANK_YOU_TITLE: 'Thank you for your booking.',
  THANK_YOU_SUB_TITLE: ' Confirmation will be sent shortly to your email id.',
  THANK_YOU_DESCRIPTION:
    'For any further queries, Please write to us at care@bag2bag.in or call us on +91-9335505099',
};

export const TITLE_MESSAGES = {
  USER_ENQUERY: 'Thank you for your enquiry',
};

export const PAYTM_CONSTANTS = {
  ERROR_CODE_227: `Your payment has been declined by your bank. Please contact your bank for any queries. If money has been deducted from your account, your bank will inform us within 48 hrs and we will refund the same.`,
  ERROR_CODE_235: 'Wallet balance Insufficient',
  ERROR_CODE_295:
    'Your payment failed as the UPI ID entered is incorrect. Please try again by entering a valid VPA or use a different method to complete the payment.',
  ERROR_CODE_334:
    'Unfortunately, Your transaction has been failed. Please try another payment method.',
  ERROR_CODE_335:
    'Unfortunately, Your transaction has been failed. Please try another payment method.',
  ERROR_CODE_401:
    'Your payment has been declined by your bank. Please contact your bank for any queries. If money has been deducted from your account, your bank will inform us within 48 hrs and we will refund the same.',
  ERROR_CODE_501: 'Paytm server is down. Please try another payment method.',
  ERROR_CODE_810:
    'Unfortunately, Your transaction has been failed. Please try again.',
};
